<template>
  <div class="input-container">
    <el-input v-model="innerValue" class="input" placeholder="请输入" maxlength="50" clearable @input="updateValue" @keydown.enter.prevent @keydown="handleInput" @focus="getFocus" @blur="lostFocus"/>
    <div class="associate-keywords" v-loading="companyNameRemoteLoading > 0" :class="{'disable-associate': companyNameRemoteLoading === 0 && companyRemoteOptions?.length === 0}" v-if="inputFocus && innerValue?.length >= 3 && innerValue?.length <= 6">
      <div class="key position-r" :class="{'active': index === cur}" v-for="(item,index) in companyRemoteOptions" :key="index" @click="clickLeft(item)">
        <p v-html="item.showWord" class="text-ol-ell"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { getQiAnswer } from "@/api/Tan/QiChaCha.js";

export default{
  props: ['value'],
  emits: ['changeCompanyName'],
  data(){
    return{
      inputFocus: false,
      innerValue: '',
      cur: -1,
      companyRemoteOptions: [],
      companyNameRemoteLoading: 0,
    }
  },
  watch:{
    inputFocus(val){
      if(!val){
        this.companyRemoteOptions = []
      }
      else{
        this.nameAssociateKeyword()
      }
    },
    innerValue(val){
      if(!val){
        this.$emit('changeCompanyName',this.innerValue)
      }
      this.nameAssociateKeyword()
    },
    value(val,oldValue){
      if(!oldValue && val){
        this.innerValue = this.value  // * 初始化赋值
        this.nameAssociateKeyword()
      }
      else if(!this.innerValue && val){
        this.innerValue = this.value  // * 初始化赋值
        this.nameAssociateKeyword()
      }
    },
  },
  mounted(){
    this.innerValue = this.value  // * 初始化赋值
    this.nameAssociateKeyword()
  },
  methods:{
    getFocus(){
      this.inputFocus = true
    },
    lostFocus(){
      setTimeout(() => {
        this.inputFocus = false
      }, 500);
    },
    handleInput(event){
      const code = event.code
      if(code === 'ArrowUp'){
        if(this.cur < 0) return
        this.cur -= 1
      }
      else if(code === 'ArrowDown'){
        if(this.cur > this.companyRemoteOptions?.length - 1) return
        this.cur += 1
      }
      else if(code === 'Enter'){
        if(this.cur === -1 || this.cur === this.companyRemoteOptions?.length){
          return
        }
        const item = this.companyRemoteOptions[this.cur]
        this.clickLeft(item)
      }
    },
    clickLeft(item){
      this.innerValue = item.Name
      this.$emit('changeCompanyName',this.innerValue)
    },
    updateValue(){
      this.$emit('changeCompanyName',this.innerValue)
    },
    nameAssociateKeyword(){
      if(this.innerValue?.length < 3 || this.innerValue?.length > 6){
        return
      }
      this.companyNameRemoteLoading += 1
      getQiAnswer(this.innerValue).then(res=>{
        const data = JSON.parse(res.data)
        this.companyRemoteOptions = data.Result?.map((item)=>{
          const word = JSON.parse(JSON.stringify(this.innerValue)).toLocaleUpperCase()
          word.split('').forEach((w)=>{
            if(!item.showWord) item.showWord = item.Name.toLocaleUpperCase().replaceAll(w, `<span>${w}</span>`)
            else item.showWord = item.showWord.replaceAll(w, `<span>${w}</span>`)
          })
          return item
        }) || []
      }).finally(()=>{
        this.companyNameRemoteLoading -= 1
      })
    },
  }
}
</script>


<style lang="scss" scoped>
.input-container{
  position: relative;
  .input{
    width: 300px;
    z-index: 201;
  }
}
.associate-keywords{
  width: 100%;
  border: 1px solid $--color-theme;
  border-top: none;
  padding-top: 6px;
  position: absolute;
  max-height: 200px;
  min-height: 100px;
  overflow-y: auto;
  left: 0;
  top: 36px;
  box-sizing: border-box;
  z-index: 200;
  &::before{
    content: '';
    width: calc(100% - 30px);
    position: absolute;
    left: 15px;
    top: 2px;
    background: #E8E8E8;
    height: 1px;
    z-index: 100;
  }
  border-radius: 0 0 4px 4px;
  background-color: #FFFFFF;
  .active{
    background-color:  #F4F7FC !important;
  }
  .key{
    color: #111111;
    box-sizing: border-box;
    padding: 0px 15px;
    font-size: 14px;
    cursor: pointer;
    background-color: #ffffff;
    &:hover{
      background-color:  #F4F7FC;
    }
    p{
      max-width: 100% !important;
      :deep(span){
        color: $--color-theme !important;
      }
    }
    .expert{
      position: absolute;
      color: $--color-theme;
      font-size: 14px;
      right: 14px;
      line-height: 18px;
      top: 50%;
      margin-top: -9px;
    }
  }
}
.disable-associate{
  display: none !important;
}

</style>